/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_None_ScopeInputs */

const es_marketplace_seo_license_row_none_scope = /** @type {(inputs: Marketplace_Seo_License_Row_None_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No requiere carnet. Ideal para iniciarse como patrón un día.`)
};

const gl_marketplace_seo_license_row_none_scope = /** @type {(inputs: Marketplace_Seo_License_Row_None_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non require carnet. Ideal para iniciarse como patrón un día.`)
};

const en_marketplace_seo_license_row_none_scope = /** @type {(inputs: Marketplace_Seo_License_Row_None_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No certificate required. Ideal for a first day as skipper.`)
};

/**
* | output |
* | --- |
* | "No certificate required. Ideal for a first day as skipper." |
*
* @param {Marketplace_Seo_License_Row_None_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_none_scope = /** @type {((inputs?: Marketplace_Seo_License_Row_None_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_None_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_none_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_none_scope(inputs)
	return es_marketplace_seo_license_row_none_scope(inputs)
});